export const itemsLabel = "QFnkfe";
export const unreadLabel = "F5R0eb";
export default {itemsLabel,unreadLabel};